module.exports = __webpack_public_path__ + "img/Qclubs.978aecd3.jpg";